import {Navigate, Outlet, useLocation, useParams} from 'react-router-dom';
import * as React from "react";
import {useSelector} from "react-redux";
import {RootState} from "./store";

export const PaymentRoute = () => {
    const location = useLocation()
    const params = useParams()

    const isPaymentEnabled = useSelector((state: RootState) => {
        return state.payment.paymentEnabled
    })

    if (params.redirect_status) {
        return <Outlet/>
    }

    return isPaymentEnabled ? <Outlet/> : <Navigate to={{pathname: "/enrollment"}} replace state={{from: location}}/>
}
